<script>
import moment from "moment";
import { mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
const api = ClientFactory.get("budgetreport");
const apiFile = ClientFactory.get("files");
const apiDropdown = ClientFactory.get("dropdowns");
export default {
    data() {
        return{
            inputFileType1: null,
            inputFileType2: null,
            inputFileType3: null,
            inputPeriod: 4,
            inputPeriodDetail: 1,
            inputReportName: "",
            inputCate: -1,
            inputReportYear: new Date().getFullYear(),
            inputPublishDate: new Date(),
            inputPublishTime: moment(new Date()).format("HH:mm:ss"),
            inputDocumentNo: "",
            inputNote: "",
            listCate: [],
            listPeriodDetail: [],
            listPeriod: [
                {
                    label: "Năm",
                    value: 4,
                },
                {
                    label: "Nửa năm",
                    value: 3,
                },
                {
                    label: "Tháng",
                    value: 1,
                },
                {
                    label: "Quý",
                    value: 2,
                },
            ],
            listMonth: [
                {
                    label: "Tháng 1",
                    value: 1,
                },
                {
                    label: "Tháng 2",
                    value: 2,
                },
                {
                    label: "Tháng 3",
                    value: 3,
                },
                {
                    label: "Tháng 4",
                    value: 4,
                },
                {
                    label: "Tháng 5",
                    value: 5,
                },
                {
                    label: "Tháng 6",
                    value: 6,
                },
                {
                    label: "Tháng 7",
                    value: 7,
                },
                {
                    label: "Tháng 8",
                    value: 8,
                },
                {
                    label: "Tháng 9",
                    value: 9,
                },
                {
                    label: "Tháng 10",
                    value: 10,
                },
                {
                    label: "Tháng 11",
                    value: 11,
                },
                {
                    label: "Tháng 12",
                    value: 12,
                },
            ],
            listQuarter: [
                {
                    label: "Quý 1",
                    value: 1,
                },
                {
                    label: "Quý 2",
                    value: 2,
                },
                {
                    label: "Quý 3",
                    value: 3,
                },
                {
                    label: "Quý 4",
                    value: 4,
                },
            ],
            listHalfYear: [
                {
                    label: "6 tháng đầu năm",
                    value: 1,
                },
                {
                    label: "6 tháng cuối năm",
                    value: 2,
                },
            ],
        }
    },
    methods: {
        ...mapActions("ui", ["loading", "closeLoading", "notify"]),
        periodChange() {
            if (this.inputPeriod == 1) {
                this.listPeriodDetail = this.listMonth;
            } else if (this.inputPeriod == 2)
                this.listPeriodDetail = this.listQuarter;
            else if (this.inputPeriod == 3)
                this.listPeriodDetail = this.listHalfYear;
            else {
                this.listPeriodDetail = [{ value: -1, label: "" }];
                this.inputPeriodDetail = -1;
            } 
        },
        validator() {
            return (!this.errors.any() && this.inputReportName !== "" && this.inputDocumentNo !== "");
        },
        validateFile(event, fileType) {
            switch (fileType) {
                case 1:
                     if (event.length != 0) {
                        this.inputFileType1 = event[0];
                    } else {
                        this.inputFileType1 = null;
                    }
                    break;
                case 2:
                    if (event.length != 0) {
                        this.inputFileType2 = event[0];
                    } else {
                        this.inputFileType2 = null;
                    }
                    break;
                case 3:
                    if (event.length != 0) {
                        this.inputFileType3 = event[0];
                    } else {
                        this.inputFileType3 = null;
                    }
                    break;
            }
        },
        async create(){
            this.$validator.validateAll();
            if (!this.validator()) {
                return this.notify({
                    error: true,
                    text: "Dữ liệu không hợp lệ.",
                });
            }

            this.loading(this.$vs);
            let fileIdType1 = null;
            if (this.inputFileType1 != null){
                response = await apiFile.uploadFile(this.inputFileType1);
                if (typeof response.error !== "undefined" || response.data.status === "failed") {
                    this.closeLoading();
                    return this.notify({
                        error: true,
                        text: response.error || response.data.message,
                    });
                }
                fileIdType1 = response.data.fileIds[0];
            }

            let fileIdType2 = null
            if (this.inputFileType2 != null){
                response = await apiFile.uploadFile(this.inputFileType2);
                if (typeof response.error !== "undefined" || response.data.status === "failed") {
                    this.closeLoading();
                    return this.notify({
                        error: true,
                        text: response.error || response.data.message,
                    });
                }
                fileIdType2 = response.data.fileIds[0];
            }

            let fileIdType3 = null;
            if (this.inputFileType3 != null){
                let response = await apiFile.uploadFile(this.inputFileType3);
                if (typeof response.error !== "undefined" || response.data.status === "failed") {
                    this.closeLoading();
                    return this.notify({
                        error: true,
                        text: response.error || response.data.message,
                    });
                }
                fileIdType3 = response.data.fileIds[0];
            }

            let response = await api.insReport({
                report_type_id: 1,
                cate_id: this.inputCate,
                report_name: this.inputReportName,
                report_year: this.inputReportYear,
                period_type: this.inputPeriod,
                period_value: this.inputPeriodDetail,
                document_no: this.inputDocumentNo,
                publish_date: moment(this.inputPublishDate).format("DD/MM/YYYY") + " " + this.inputPublishTime,
                note: this.inputNote,
                status: 1
            });
            if (typeof response.error !== "undefined" || response.data.status === "failed") {
                return this.notify({
                    error: true,
                    text: response.error || response.data.message,
                });
            }
            var reportId = response.data.data[0].data;
            
            if (this.inputFileType1 != null){
                response = await api.insFile({
                    budget_report_id: reportId,
                    file_type_id: 1,
                    file_id: fileIdType1
                });
                if (typeof response.error !== "undefined" || response.data.status === "failed") {
                    return this.notify({
                        error: true,
                        text: response.error || response.data.message,
                    });
                }
            }
            if (this.inputFileType2 != null){
                response = await api.insFile({
                    budget_report_id: reportId,
                    file_type_id: 2,
                    file_id: fileIdType2
                });
                if (typeof response.error !== "undefined" || response.data.status === "failed") {
                    return this.notify({
                        error: true,
                        text: response.error || response.data.message,
                    });
                }
            }
            
            if (this.inputFileType3 != null){
                response = await api.insFile({
                    budget_report_id: reportId,
                    file_type_id: 3,
                    file_id: fileIdType3
                });
                if (typeof response.error !== "undefined" || response.data.status === "failed") {
                    return this.notify({
                        error: true,
                        text: response.error || response.data.message,
                    });
                }
            }
            this.closeLoading();
            this.$router.back();
            return this.notify({
                text: "Thêm mới dữ liệu thành công",
            });
        },
    },
    async created() {
        this.loading(this.$vs);
        this.listCate = await apiDropdown.getItemsTree('BUDGET_REPORT_CATE');
        this.inputCate = this.listCate[0].value;
        this.closeLoading();
    },
    destroyed() {
        this.closeLoading();
    },
}
</script>

<template>
	<div>
		<CCard>
			<CCardHeader class="pt-1 pb-1">
				<h4>Thông tin báo cáo</h4>
			</CCardHeader>
			<CCardBody class="pt-1 pb-1">
				<CRow class="mb-2">
					<CCol md="6">
						<CInput
							v-model="inputReportName"
							label="Tên báo cáo"
							v-validate="'required'"
							name="Tên báo cáo"
						/>
						<span class="text-danger text-sm">{{errors.first("Tên báo cáo")}}</span>
					</CCol>
                    <CCol md="6">
						<CSelect
							:value.sync="inputCate"
							label="Danh mục"
							:options="listCate"
						/>
					</CCol>
				</CRow>
				<CRow class="mb-2">
					<CCol md="3">
						<CSelect
							label="Kỳ báo cáo"
							:options="listPeriod"
							:value.sync="inputPeriod"
							@change="periodChange"
						/>
					</CCol>
                    <CCol md="3">
                        <CInput
							v-model="inputReportYear"
                            type="number"
							label="Năm"
						/>
                    </CCol>
                    <CCol sm="3">
						<CSelect
							:class="inputPeriod != 4 && inputPeriod != -1 ? 'visible' : 'invisible'"
							label="Loại kỳ báo cáo"
							:options="listPeriodDetail"
							:value.sync="inputPeriodDetail"
						/>
					</CCol>
				</CRow>
                <CRow class="mb-2">
					<CCol md="3">
						<CInput
							v-model="inputDocumentNo"
							label="Số văn bản công bố"
                            name="Số văn bản công bố"
                            v-validate="'required'"
						/>
                        <span class="text-danger text-sm">{{errors.first("Số văn bản công bố")}}</span>
					</CCol>
                    <CCol md="2">
						<label for="datepicker">Ngày công bố</label>
						<b-form-datepicker
							id="datepicker"
							v-model="inputPublishDate"
							class="mb-2"
                            locale="vi"
                            placeholder="Chọn ngày công bố"
                            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                            :hide-header=true
                            label-help=""
                            :value-as-date=true>
                        </b-form-datepicker>
					</CCol>
                    <CCol md="2">
                        <label for="timepicker">Giờ công bố</label>
						<b-form-timepicker
                            id="timepicker"
                            v-model="inputPublishTime"
                            placeholder="Chọn giờ công bố"
                            hourCycle="h23"
                            :hide-header=true
                            no-close-button
                            locale="vi">
                        </b-form-timepicker>
					</CCol>
				</CRow>
                <CRow class="mb-2">
                    <CCol md="3">
						<CInputFile label="File văn bản/báo cáo" @change="validateFile($event, 1)" name="File văn bản/báo cáo"/>
					</CCol>
                    <CCol md="3">
						<CInputFile label="File số liệu thống kê" @change="validateFile($event, 2)" name="Số liệu thống kê"/>
					</CCol>
                    <CCol md="3">
						<CInputFile label="File đính kèm khác" @change="validateFile($event, 3)" name="File đính kèm khác"/>
					</CCol>
                </CRow>
                <CRow class="mb-2">
					<CCol md="12">
						<CTextarea
							v-model="inputNote"
							label="Ghi chú"
							rows="5"
						/>
					</CCol>
				</CRow>
				<CRow>
					<CCol md="12">
						<div class="text-center">
                            <vs-button class="d-inline custom_btn_search" square danger @click="$router.back()"><i class="bx bx-left-arrow-alt"></i> &nbsp;Quay lại</vs-button>
							<vs-button class="d-inline" square @click="create"><i class="bx bx-save"></i> &nbsp;Thêm mới</vs-button>
						</div>
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>
	</div>
</template>